import { Injectable } from '@angular/core';
import { IPermissionResponseDTO } from '@app/infrastructure/permission/permission.model';
import { PermissionServiceReworked } from '@app/infrastructure/permission/permission.service.reworked';
import { ApiFacadeService } from '@app/services/api-facade.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter, map, shareReplay, switchMap, take, tap } from 'rxjs/operators';
import { FEATURE_FLAGS } from '@app/infrastructure/feature-flag-manager/feature-flag-list';
import { FeatureFlagManagerService } from '@app/infrastructure/feature-flag-manager/feature-flag-manager.service';

@Injectable({
	providedIn: 'root',
})
export class PermissionApiService {
	private _permission$: BehaviorSubject<IPermissionResponseDTO> = new BehaviorSubject<IPermissionResponseDTO>(null);

	private _permissionSource$ = this.featureFlagManagerService.flags$.pipe(
		filter((flags) => !!Object.keys(flags).length),
		take(1),
		switchMap(() => {
			const enableInitResources =
				this.featureFlagManagerService.flags[FEATURE_FLAGS.ENABLE_ENABLE_INITIAL_RESOURCES_BFF_ENDPOINT];
			const source$ = enableInitResources
				? this._permission$
				: this.apiFacade.post<IPermissionResponseDTO>('permission-manager/get-permissions', {});

			return source$.pipe(
				filter((response: IPermissionResponseDTO) => response.success),
				tap((response: IPermissionResponseDTO) => this.permissionService.handlePermissions(response.permissions)),
				map((response: IPermissionResponseDTO) => response.success),
			);
		}),
		shareReplay(1),
	);

	constructor(
		private apiFacade: ApiFacadeService,
		private permissionService: PermissionServiceReworked,
		private featureFlagManagerService: FeatureFlagManagerService,
	) {}

	public loadPermissions(): Observable<boolean> {
		return this._permissionSource$;
	}

	public updatePermissions(data: IPermissionResponseDTO): void {
		this._permission$.next(data);
	}
}
